import { NgModule } from '@angular/core';

// Modules Material utilises

// Autres modules externes utilises 

// Modules communs utilises
import { JSR310LocalDatesModule } from '../../shared/jsr310-localdates/jsr310-localdates.module';

// Composants metiers

// Services metier
import { CachedDataSurveyService } from './services/cached-data-survey.service';

@NgModule({
	imports: [
		JSR310LocalDatesModule,
	],
	providers: [
		CachedDataSurveyService,
	],
	declarations: [
	],
	exports: [
	]
})
export class TasksModule {
	constructor() { }
}